<template lang="pug">

  .healthcheck
    div
      p.m-0 Aplicación: <b>RFI - Solicitudes de Información</b>
      p.m-0 Host: <b>{{config.apiHost}}</b>
      p.m-0 Release: <b>{{config.backendVersion}}</b>
      hr(style="color: black; background-color: black")
      p.m-0(v-if="this.config.DB_conn == false" ) DB Connection: <span style="font-weight: bold; color: red">ERROR</span>
      p.m-0(v-if="this.config.DB_conn == true" ) DB Connection: <span style="font-weight: bold; color: green">OK</span>
      p.m-0(v-if="this.config.CAS == false" ) CAS: <span style="font-weight: bold; color: red">ERROR</span>
      p.m-0(v-if="this.config.CAS == true" ) CAS: <span style="font-weight: bold; color: green">OK</span>
      p.m-0(v-if="this.config.Notificador == false" ) Notificador: <span style="font-weight: bold; color: red">ERROR</span>
      p.m-0(v-if="this.config.Notificador == true" ) Notificador: <span style="font-weight: bold; color: green">OK</span>

</template>

<script>
import {HTTP} from "../http";

export default {
  name: "Healthcheck",
  data() {
    return {
      config: [],
    }
  },
  async created(){
    this.config = (await HTTP.get('/config/checkServices')).data
  },
}
</script>

<style scoped>

</style>
